import { ref } from "vue";
import { defineStore } from "pinia";
import { SetupStoreId } from "@/store/plugins";
import { setLocale, getDefaultLocale, localeOptions } from "@/locales";

export const useAppStore = defineStore(SetupStoreId.App, () => {
  /** 重新加载页面的标志 */
  const reloadFlag = ref(true);

  /** 当前语言 */
  const locale = ref<App.I18n.LangType>(getDefaultLocale());

  /**
   * 重新加载页面
   *
   * @param duration 重新加载的持续时间
   */
  async function reloadPage(duration = 0) {
    reloadFlag.value = false;

    if (duration) {
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve(true);
        }, duration);
      });
    }

    reloadFlag.value = true;
  }

  /**
   * 切换语言
   * @param lang - 语言类型
   */
  function changeLocale(lang: App.I18n.LangType): void {
    locale.value = lang;
    setLocale(lang);
  }

  return {
    reloadFlag,
    locale,
    localeOptions,
    changeLocale,
    reloadPage,
  };
});
